const en = {
  work_name: "Work name",
  work: "Work",
  author: "Author",
  rating: "Rating",
  evaluation: "Evaluation",
  work_evaluation: "Work evaluation",
  ai_editor: "AI editor",
  ai_evaluation: "AI Evaluation",
  number_of_works: "Lesson plan",
  view_works: "View works",
  free_creation: "Free creation",
  theme_creation: "Theme creation",
  student_works: "Student works",
  theme_name: "Theme name",
  weight: "Weight",
  edit: "AI Edit",
  style: "Style",
  perspective: "Perspective",
  texture: "Texture",
  composition: "Composition",
  color: "Color"
};

const zh_hant = {
  work_name: "作品名稱",
  work: "作品",
  author: "作者",
  rating: "評分",
  evaluation: "評價",
  work_evaluation: "作品評價",
  number_of_works: "教案",
  ai_editor: "AI 編輯",
  ai_evaluation: "AI 評價",
  view_works: "查看作品",
  free_creation: "自由創作",
  theme_creation: "主題創作",
  student_works: "學生作品",
  theme_name: "主題名稱",
  weight: "權重值",
  edit: "AI編輯",
  style: "風格",
  perspective: "透視",
  texture: "質感",
  composition: "構圖",
  color: "色彩"
};
const zh_cn = {
  work_name: "作品名称",
  work: "作品",
  author: "作者",
  rating: "评分",
  evaluation: "评价",
  work_evaluation: "作品评价",
  number_of_works: "教案",
  ai_editor: "AI 编辑",
  ai_evaluation: "AI 评价",
  view_works: "查看作品",
  free_creation: "自由创作",
  theme_creation: "主题创作",
  student_works: "学生作品",
  theme_name: "主题名称",
  weight: "权重值",
  edit: "AI编辑",
  style: "风格",
  perspective: "透视",
  texture: "质感",
  composition: "构图",
  color: "色彩"
};

const es = {
  work_name: "Nombre de la obra",
  work: "Obra de arte",
  author: "Autor",
  rating: "Calificación",
  evaluation: "Evaluación",
  work_evaluation: "Evaluación de la obra de arte",
  number_of_works: "Plan de lección",
  ai_editor: "Editor IA",
  ai_evaluation: "Evaluación IA",
  view_works: "Ver obras de arte",
  free_creation: "Creación libre",
  theme_creation: "Creación de tema",
  student_works: "Obras de arte de los estudiantes",
  theme_name: "Nombre del tema",
  weight: "Peso",
  edit: "Edición IA",
  style: "Estilo",
  perspective: "Perspectiva",
  texture: "Textura",
  composition: "Composición",
  color: "Color"
};
export default { en, zh_hant, es, zh_cn };
